<form [formGroup]="form" (ngSubmit)="save()">
  <div class="form__group" [ngClass]="{'form__error': isSubmitted() && f[field.key].errors}">
    <div class="p-float-label">
      <p-autoComplete type="email" [formControlName]="field.key" (onBlur)="save()" [suggestions]="filteredDomains"
                      (completeMethod)="onDomainFilter($event)"></p-autoComplete>
      <label>
        <ng-container *ngIf="field.key === 'correo'; else defaultLabel">
          {{field.label}} *
        </ng-container>
        <ng-template #defaultLabel>{{ field.label }} *</ng-template>
      </label>
    </div>

    <span class="form__msgError" *ngIf="isSubmitted() && f[field.key].errors">
      <small class="p-error" *ngIf="f[field.key].hasError('required')">Requerido</small>
      <small class="p-error" *ngIf="f[field.key].hasError('email')">Inválido</small>
      <small class="p-error" *ngIf="f[field.key]?.hasError('duplicate')">Email ya existe*</small>
      <small class="p-error" *ngIf="f[field.key]?.hasError('invalid')">Email es invalido*</small>
    </span>
    <span class="form__msgValidate" *ngIf="f[field.key].pending">
        <small class="p-validate">
          <i class="pi pi-spin pi-spinner"></i>
         <span>Validando email...</span>
        </small>
      </span>
  </div>

  <div class="form__group" [ngClass]="{'form__error': isSubmitted() && f[field.key+'_checkbox'].errors}">
    <div class="form__checkbox">
      <div class="form__checkboxItem">
        <p-checkbox [binary]="true" [formControlName]="field.key+'_checkbox'"></p-checkbox>
        <label class="small">
          Autorizo a Krediya a usar mi correo electrónico para enviar mi recibo de pago. Para más información, visite
          <a href="https://www.krediya.com/es/politica-de-tratamiento-de-datos-personales?hsLang=es-pa" target="_blank">Política de Tratamiento de Datos Personales</a>
          y <a href="https://www.krediya.com.pa/terminos-y-condiciones" target="_blank">Términos y Condiciones</a>.
        </label>
      </div>
    </div>

    <span class="form__msgError mt-15" *ngIf="isSubmitted() && f[field.key+'_checkbox'].errors">
      <small class="p-error" *ngIf="f[field.key+'_checkbox'].getError('required')">Para poder continuar debes aceptar la autorización</small>
    </span>
  </div>
</form>
